<app-modal class="position-fixed w-100 h-100" style="z-index: 1060"></app-modal>
<div>
  <app-navbar></app-navbar>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
